import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DeveloperToolsService {
  readonly emailOverride = signal<boolean>(false);
}
